module.exports = __webpack_public_path__ + "static/media/contact_3.e4c72bf8.jpg";